import React from 'react';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import 'photoswipe/dist/photoswipe.css';
import { Item} from "react-photoswipe-gallery";

export default function LiegenLayout(props) {

  return (
    <>
      <Grid2 container display="flex" flexDirection="column">
        {props.data.left.map((item, index) => (
          <Grid2 sx={{py:0,marginY:-1}}>
            <Item
              original={item.url}
              thumbnail={item.tn}
              width={item.width}
              height={item.height}
              caption={props.captionFN(item.orig,"DIG_PHOTO","INKJET_PAPER_ALU","68x45")}
            >
              {({ref,open}) => (
                <img ref={ref} 
                  onClick={open} 
                  src={item.tn}
                  alt={item.orig}
                />
              )}
            </Item>
          </Grid2>
        ))}
      </Grid2>
      <Grid2 container display="flex" flexDirection="column">
        {props.data.centerleft.map((item, index) => (
          <Grid2 sx={{pl:2,pr:0,py:0,margin:-1}}>
            <Item
              original={item.url}
              thumbnail={item.tn}
              width={item.width}
              height={item.height}
              caption={props.captionFN(item.orig,"DIG_PHOTO","INKJET_PAPER_ALU","68x45")}
            >
              {({ref,open}) => (
                <img ref={ref} 
                  onClick={open} 
                  src={item.tn}
                  alt={item.orig}
                />
              )}
            </Item>
          </Grid2>
        ))}
      </Grid2>
      <Grid2 container display="flex" flexDirection="column">
        {props.data.centercenter.map((item, index) => (
          <Grid2 sx={{py:0,margin:-1}}>
            <Item
              original={item.url}
              thumbnail={item.tn}
              width={item.width}
              height={item.height}
              caption={props.captionFN(item.orig,"DIG_PHOTO","INKJET_PAPER_ALU","68x45")}
            >
              {({ref,open}) => (
                <img ref={ref} 
                  onClick={open} 
                  src={item.tn}
                  alt={item.orig}
                />
              )}
            </Item>
          </Grid2>
        ))}
      </Grid2>
      <Grid2 container display="flex" flexDirection="column">
        {props.data.centerright.map((item, index) => (
          <Grid2 sx={{pr:2,pl:0,py:0,margin:-1}}>
            <Item
              original={item.url}
              thumbnail={item.tn}
              width={item.width}
              height={item.height}
              caption={props.captionFN(item.orig,"DIG_PHOTO","INKJET_PAPER_ALU","68x45")}
            >
              {({ref,open}) => (
                <img ref={ref} 
                  onClick={open} 
                  src={item.tn}
                  alt={item.orig}
                />
              )}
            </Item>
          </Grid2>
        ))}
      </Grid2>
      <Grid2 container display="flex" flexDirection="column">
      {props.data.right.map((item, index) => (
          <Grid2 sx={{py:0,marginY:-1}}>
            <Item
              original={item.url}
              thumbnail={item.tn}
              width={item.width}
              height={item.height}
              caption={props.captionFN(item.orig,"DIG_PHOTO","INKJET_PAPER_ALU","68x45")}
            >
              {({ref,open}) => (
                <img ref={ref} 
                  onClick={open} 
                  src={item.tn}
                  alt={item.orig}
                />
              )}
            </Item>
          </Grid2>
        ))}
      </Grid2>

    </>
  )
}
